import React, { useState, useEffect } from 'react';
import './App.css';
import Loader from './components/Loader/Loader';
import StartMenu from './components/StartMenu/StartMenu';
import NavbarGame from './components/NavbarGame/NavbarGame';
import InfoPage from './components/InfoPage/InfoPage';
import Alphabet from './components/Alphabet/Alphabet';
import GamePage from './components/GamePage/GamePage';
import FinishGame from './components/FinishGame/FinishGame';
import textContents from './data/dataInterface';
import { setTimeout } from 'timers';

let imagesName = {};
let imagesArr = {}; //массив с картинками, ключ - название картинки
let langv = 'rus';
let isLoad = false;
let num = 0;
let alphabetRus = [];
let alphabetFin = [];
let wordsRus = {};
let wordsFin = {};


    //создание массива всех слов игры 
function GameWords(content) {
    let id = 0;
    let words = [];
    for (let [letter, color] of Object.entries(textContents.colorAlphabetRus)) {
       
        alphabetRus.push({
            id: id,
            letter: letter,
            color: color
        });
        id++;
    };
    id = 0;
    for (let [letter, color] of Object.entries(textContents.colorAlphabetFin)) {
       
        alphabetFin.push({
            id: id,
            letter: letter,
            color: color
        });
        id++;
    };
    //массив слов в соединении с буквой и адресом картинки
   for (let i = 0; i < alphabetRus.length; i++) {
       words = [];
       let curLetter = alphabetRus[i].letter;
        Object.keys(content).forEach(function (key) {
            for (let [letter, curWord] of Object.entries(content[key].rus)) {
           
            if (letter === curLetter) {
                words.push({
                    word: curWord,
                    ImgName: key
                });
            }
        }
    });
       wordsRus[curLetter] = words;
        };

    for (let i = 0; i < alphabetFin.length; i++) {
        words = [];
        let curLetter = alphabetFin[i].letter;
        Object.keys(content).forEach(function (key) {
            
            for (let [letter, curWord] of Object.entries(content[key].fin)) {
               
                if (letter === curLetter) {
                    words.push({
                        word: curWord,
                        ImgName: key
                    });
                }
            }
        });
        wordsFin[curLetter] = words;

    };
};
    


function GameContent(content, callback) {
    imagesName = Object.keys(content); 

    for (let id of imagesName) {                 //чтение в кэш картинок контента, ключ - название картинки

        let urlFile = process.env.PUBLIC_URL + '/content/' + id + '.png';
        imagesArr[id] = new Image(550, 315);
        imagesArr[id].src = urlFile;
    };
    imagesArr['bgStartFin'] = new Image(695, 594);
    imagesArr['bgStartFin'].src = process.env.PUBLIC_URL + '/interface/bgStartFin.png';
    imagesArr['bgStartRus'] = new Image(695, 594);
    imagesArr['bgStartRus'].src = process.env.PUBLIC_URL + '/interface/bgStartRus.png';

    imagesArr['bgInfoFin'] = new Image(695, 594);
    imagesArr['bgInfoFin'].src = process.env.PUBLIC_URL + '/interface/bgInfoFin.png';
    imagesArr['bgInfoRus'] = new Image(695, 594);
    imagesArr['bgInfoRus'].src = process.env.PUBLIC_URL + '/interface/bgInfoRus.png';

    imagesArr['bgFinishRus'] = new Image(695, 594);
    imagesArr['bgFinishRus'].src = process.env.PUBLIC_URL + '/interface/bgFinishRus.png';
    imagesArr['bgFinishFin'] = new Image(695, 594);
    imagesArr['bgFinishFin'].src = process.env.PUBLIC_URL + '/interface/bgFinishFin.png';

    GameWords(content);
    callback();
};

function readData() { //чтение данных 
    let address = window.top.document.location.href; //определение языка на котором находится игра
    if (address.indexOf('/fin/') > 0) langv = 'fin';

    GameContent(textContents.content, function () { isLoad = true; });
};

readData();



export default function App() {
    const [isLoading, setIsLoading] = useState(false);  //окно1,признак загрузки контента
    const [isStart, setIsStart] = useState(false);      //окно2,начало игры с нуля, выбор языка
    const [isInfo, setIsInfo] = useState(false);        //окно3, инструкция к игре
    const [isNavbar, setIsNavbar] = useState(false);	//окно4, верхнее меню
    const [isAlphabet, setIsAlphabet] = useState(false);  //окно5, алфавит
    const [isGame, setIsGame] = useState(false);		//окно6, картинка и  слово
    const [isFinish, setIsFinish] = useState(false);	//окно7,  конец игры

    const [curAlphabet, setCurAlphabet] = useState(' ');
    const [curLetter, setCurLetter] = useState('');
    const [curLetterWords, setCurLetterWords] = useState(' ');
    const [curWords, setCurWords] = useState(' ');
    const [curWordId, setCurWordId] = useState(-1);
    const [curColor, setCurColor] = useState('1');
    const [lang, setLang] = useState(langv);
    const [step, setStep] = useState(0);
    const [curImg, setCurImg] = useState('');
    const [isLetter, setIsLetter] = useState(true);



   const preloadTime = (() => {
       for (let i = 0; i < 4; i++) {
           if (num > 0) break;
           if (isLoad && num === 0) {
               setIsLoading(isLoad);
               setCurAlphabet(alphabetRus);
               setCurWords(wordsRus);             
              
               setIsStart(true);
               num++;
               break;
           }
           setTimeout(setIsLoading, 2000, isLoad);
       }
    });
    useEffect(() => {
        setTimeout(preloadTime, 3000);
    }, [isLoading]);


    const handleComponent = ((pri, letter, id) => { 
        if (pri === 'rus' && lang === 'fin') {
            setLang('rus');
            langv = lang;
            setCurAlphabet(alphabetRus);
            setCurWords(wordsRus);     
            if (isGame) {
                setIsGame(false);
                setIsAlphabet(true);
            };
        };
        if (pri === 'fin' && lang === 'rus') {
            setLang('fin');
            langv = lang;
            setCurAlphabet(alphabetFin);
            setCurWords(wordsFin);
            if (isGame) {
                setIsGame(false);
                setIsAlphabet(true);
            };

        } 
        if (pri === 'start') {
            setIsStart(false);
            setIsInfo(true);
            setIsNavbar(true);
            setStep(0);
        }; 
        if (pri === 'abc') {
            setIsGame(false);
            setIsAlphabet(true);
        }; 
        if (pri === 'continue') {
            setIsInfo(false);
            setIsAlphabet(true);
        };
        if (pri === 'info') {
            setIsInfo(true);
            setIsGame(false);
            setIsAlphabet(false);
            
        };

        if (pri === 'toStart') {
            setIsInfo(false);
            setIsGame(false);
            setIsAlphabet(false);
            setIsNavbar(false);
            setIsStart(true);
            setIsFinish(false);
        } 
        if (pri === 'prev') {
            if (curWordId === -1) {   //проверяем смена буквы или слова
                if (step === 0) {                 //первая буква
                    setIsGame(false);
                    setIsAlphabet(true);
                }
                else {
                    let LetterNew = curAlphabet[step - 1].letter;
                    setStep(step - 1);
                    setCurLetter(LetterNew);
                    setCurColor(curAlphabet[step - 1].color);

                    if (curWords[LetterNew].length === 0) {
                        setIsLetter(true);
                        setCurLetterWords('');
                    }
                    else {
                        setCurLetterWords(curWords[LetterNew]);
                        setCurWordId(curWords[LetterNew].length - 1);

                        setCurImg(curWords[LetterNew][curWords[LetterNew].length - 1]);
                        setIsLetter(false);
                    }
                }
            }
            else {
                if (curWordId === 0) {
                    setIsLetter(true);
                    setCurWordId(-1);
                }
                else {
                    setCurWordId(curWordId - 1);
                    setCurImg(curLetterWords[curWordId - 1]);
                    setIsLetter(false);
                }

            }

        //    setImgId(imagesName[step - 1]);
           
        };
        if (pri === 'next') {
            if ((curLetterWords.length === 0) || (curLetterWords.length === (curWordId + 1))) {   //проверяем смена буквы или слова
                if (step === (curAlphabet.length - 1)) {                 //последняя буква
                    setIsGame(false);
                    setIsFinish(true);
                }
                else {
                    let LetterNew = curAlphabet[step + 1].letter;
                    setStep(step + 1);
                    setCurLetter(LetterNew);
                    setCurColor(curAlphabet[step + 1].color);
                    setIsLetter(true);
                    setCurLetterWords(curWords[LetterNew]);
                    setCurWordId(-1);
                    setCurImg(null);
                }
            }
            else {
                setCurWordId(curWordId + 1);
                setCurImg(curLetterWords[curWordId + 1]);
                setIsLetter(false);
            }
       
        };

        if (pri === 'newLetter') {
            setIsAlphabet(false);
            setStep(id);
            setIsGame(true);
            setCurLetter(letter);
            setCurColor(curAlphabet[id].color);
            setIsLetter(true);
            setCurLetterWords(curWords[letter]);
            setCurWordId(-1);
        };
        if (pri === 'beginA') {
            if (lang === 'rus') letter = 'А';
            else letter = 'A';
            setIsAlphabet(false);
            setStep(0);
            setIsGame(true);
            setCurLetter(letter);
            setCurColor(curAlphabet[0].color);
            setIsLetter(true);
            setCurLetterWords(curWords[letter]);
            setCurWordId(-1);
        };
    });

     return (
        <div className='App'>
            <div className='App-header'>
                 {!isLoading ? <Loader /> : null}
                 {isNavbar ? <NavbarGame lang={lang} onClick={(pri) => handleComponent(pri)} topMenu={textContents.topMenu}  /> : null}
                 {isStart ? (<StartMenu lang={lang} onClick={(pri) => handleComponent(pri)} startPage={textContents.startPage} src={lang === 'rus' ? imagesArr['bgStartRus'].src : imagesArr['bgStartFin'].src} />) : null}
                 {isInfo ? <InfoPage lang={lang} onClick={(pri) => handleComponent(pri)} textGame={textContents.textGame} src={lang === 'rus' ? imagesArr['bgInfoRus'].src : imagesArr['bgInfoFin'].src} /> : null}
                 {isAlphabet ? <Alphabet lang={lang} onClick={(pri, letter, id) => handleComponent(pri, letter, id)} curAlphabet={curAlphabet} textGame={textContents.textGame} /> : null}
                 {isGame ? <GamePage lang={lang} src={isLetter ? null : imagesArr[curImg.ImgName].src} onClick={(pri) => handleComponent(pri)} curImg={curImg} isLetter={isLetter} letter={curLetter} letterStyle={curColor} srcBg={lang === 'rus' ? imagesArr['bgInfoRus'].src : imagesArr['bgInfoFin'].src} /> : null}
                 {isFinish ? <FinishGame lang={lang} onClick={(pri) => handleComponent(pri)} textGame={textContents.textGame} src={lang === 'rus' ? imagesArr['bgFinishRus'].src : imagesArr['bgFinishFin'].src} /> : null}

            </div>
        </div>
    );
};